import { render, staticRenderFns } from "./AvatarUpload.vue?vue&type=template&id=166ea0a4&scoped=true"
import script from "./AvatarUpload.vue?vue&type=script&lang=js"
export * from "./AvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./AvatarUpload.vue?vue&type=style&index=0&id=166ea0a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ea0a4",
  null
  
)

export default component.exports